module.exports = ".upholstery{\r\n    padding-top:59px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/selectable-tabs/expert-screen-components/expert-upholstery/expert-upholstery.component.css
// module id = ./src/app/components/selectable-tabs/expert-screen-components/expert-upholstery/expert-upholstery.component.css
// module chunks = main